import { clsx } from 'clsx';
import { Children, FC, PropsWithChildren, ReactElement, useRef } from 'react';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperProps, SwiperSlide } from 'swiper/react';

import { Arrow } from './parts/Arrow';

import styles from './Carousel.css';
import './swiper.css';

export interface ICarouselProps {
  className?: string;
  testId?: string;
  children: ReactElement[];
  swiperOptions: SwiperProps;
}

export const Carousel: FC<PropsWithChildren<ICarouselProps>> = props => {
  const { children, testId, className, swiperOptions } = props;

  const prevRef = useRef<HTMLDivElement>(null);
  const nextRef = useRef<HTMLDivElement>(null);

  return (
    <div className={clsx(styles['wrapper'], `${className}_wrapper`)} data-testid={testId}>
      <div className={styles['container']}>
        <Swiper
          modules={[Navigation]}
          navigation={{
            prevEl: prevRef.current,
            nextEl: nextRef.current,
            disabledClass: `${className}-button-disabled`,
            addIcons: false,
          }}
          onSwiper={swiper => {
            setTimeout(() => {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              // eslint-disable-next-line no-param-reassign
              swiper.params.navigation.prevEl = prevRef.current;
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              // eslint-disable-next-line no-param-reassign
              swiper.params.navigation.nextEl = nextRef.current;
              // Re-init navigation
              swiper.navigation.destroy();
              swiper.navigation.init();
              swiper.navigation.update();
            });
          }}
          {...swiperOptions}
        >
          {Children.map(children, (child, index) => (
            <SwiperSlide className={styles['slide']} key={index}>
              {child}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      {swiperOptions.slidesPerView &&
        typeof swiperOptions.slidesPerView === 'number' &&
        Children.count(children) > swiperOptions.slidesPerView && (
          <>
            <Arrow direction={-1} ref={prevRef} />
            <Arrow direction={1} ref={nextRef} />
          </>
        )}
    </div>
  );
};
